/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYA5zaO%7Bmin-height%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1LMyvKYbGa%7Blist-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2Pgdg%7Bpadding-top%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbPgdg%7Bpadding-right%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWPgdg%7Bpadding-bottom%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QPgdg%7Bpadding-left%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842Pgdg%7Bmargin-top%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1DCdHiPgdg%7Bmargin-bottom%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2XsHFMBXau%7Bmargin-left%3Acalc(var(--link-picker-padding-left)*-1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0adFHshxaA%7Bmargin-right%3Acalc(var(--link-picker-padding-right)*-1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2dnbC%7Bpadding-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAljYU%7Bmin-height%3A5pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138425zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1DCdHi5zaO%7Bmargin-bottom%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
import { type CSSProperties, forwardRef, type ForwardRefExoticComponent, Fragment, type KeyboardEvent, type RefAttributes, useCallback, useRef } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { type LinkPickerPlugin, type LinkSearchListItemData } from '../../../../common/types';
import { MinHeightContainer } from '../../../../common/ui/min-height-container';
import { handleNavKeyDown } from '../../../../common/utils/handleNavKeyDown';
import { NoResults, testIds as noResultsTestIds } from './link-search-no-results';
import { LinkSearchListItem, testIds as searchResultItemTestIds } from './list-item';
import { useTrackResultsShown } from './use-track-results-shown';
const styles = {
  emptyStateNoResultsWrapper: "_4kiQYA5zaO"
};
const listContainerStyles = null;
const spinnerContainerStyles = null;
const listStyles = null;
const listTitleStyles: CSSProperties = {
  font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-bold, 653)",
  marginBottom: "var(--ds-space-050, 4px)",
  color: "var(--ds-text-subtle, #505258)"
};
export const messages: {
  titleRecentlyViewedFormatted: {
    id: string;
    defaultMessage: string;
    description: string;
  };
  titleResults: {
    id: string;
    defaultMessage: string;
    description: string;
  };
  searchLinkResults: {
    id: string;
    defaultMessage: string;
    description: string;
  };
} = defineMessages({
  titleRecentlyViewedFormatted: {
    id: 'fabric.linkPicker.listTitle.recentlyViewedFormatted',
    defaultMessage: 'Recently viewed',
    description: 'Describes type of items shown in the list for screen-reader users'
  },
  titleResults: {
    id: 'fabric.linkPicker.listTitle.results',
    defaultMessage: 'Results',
    description: 'Describes type of items shown in the list for screen-reader users'
  },
  searchLinkResults: {
    id: 'fabric.linkPicker.hyperlink.searchLinkResults',
    defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
    description: 'Announce search results for screen-reader users.'
  }
});
export const testIds: {
  resultListTitle: string;
  searchResultList: string;
  searchResultLoadingIndicator: string;
  tabsLoadingIndicator: string;
  searchResultItem: string;
  searchResultIcon: string;
  emptyResultPage: string;
} = {
  ...noResultsTestIds,
  ...searchResultItemTestIds,
  resultListTitle: 'link-picker-list-title',
  searchResultList: 'link-search-list',
  searchResultLoadingIndicator: 'link-picker.results-loading-indicator',
  tabsLoadingIndicator: 'link-picker.tabs-loading-indicator'
};
type LinkSearchListElement = HTMLElement;
export interface LinkSearchListProps extends Omit<React.HTMLAttributes<LinkSearchListElement>, 'onSelect' | 'onChange'> {
  items?: LinkSearchListItemData[] | null;
  isLoading: boolean;
  selectedIndex: number;
  activeIndex: number;
  adaptiveHeight: boolean;
  onChange: (objectId: string) => void;
  onSelect: (objectId: string) => void;
  onKeyDown?: (e: KeyboardEvent<LinkSearchListElement>) => void;
  ariaControls?: string;
  ariaLabelledBy?: string;
  ariaReadOnly?: boolean;
  role?: string;
  id?: string;
  hasSearchTerm?: boolean;
  activePlugin?: LinkPickerPlugin;
  /** Because we don't use the DST TabPanels component, tabPanelId is needed to set the correct aria-controls for a11y. */
  tabPanelId?: string;
  shouldRenderNoResultsImage?: boolean;
}
export const LinkSearchList: ForwardRefExoticComponent<LinkSearchListProps & RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, LinkSearchListProps>(({
  onChange,
  onSelect,
  onKeyDown,
  items,
  activeIndex,
  selectedIndex,
  isLoading,
  ariaReadOnly,
  role,
  id,
  hasSearchTerm,
  activePlugin,
  adaptiveHeight,
  className,
  tabPanelId,
  shouldRenderNoResultsImage,
  ...restProps
}, ref) => {
  let itemsContent;
  let loadingContent;
  const linkListTitle = hasSearchTerm ? messages.titleResults : messages.titleRecentlyViewedFormatted;
  useTrackResultsShown(isLoading, items, hasSearchTerm);
  const itemRefs = useRef<Record<string, HTMLElement>>({});
  const itemRefCallback = useCallback((el: HTMLElement | null, id: string) => {
    if (el === null) {
      delete itemRefs.current[id];
    } else {
      itemRefs.current[id] = el;
    }
  }, []);
  const getTabIndex = useCallback((index: number) => {
    if (selectedIndex > -1) {
      return selectedIndex === index ? 0 : -1;
    }
    if (index === 0) {
      return 0;
    }
    return -1;
  }, [selectedIndex]);
  const handleKeyDown = useCallback((event: KeyboardEvent<HTMLElement>) => {
    let updatedIndex = activeIndex;
    if (onKeyDown) {
      onKeyDown(event);
    }
    if (!items?.length) {
      return;
    }
    updatedIndex = handleNavKeyDown(event, items.length, activeIndex);
    const item = items?.[updatedIndex];
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) && item) {
      if (itemRefs.current) {
        itemRefs.current[item.objectId]?.focus();
      }
    }
  }, [activeIndex, items, onKeyDown]);
  if (items?.length === 0) {
    if (!hasSearchTerm) {
      const emptyState = activePlugin?.emptyStateNoResults?.();
      if (emptyState) {
        return <div id={tabPanelId} className={ax([styles.emptyStateNoResultsWrapper])}>
							{emptyState}
						</div>;
      }
    }
    return <div id={tabPanelId}>
					<NoResults shouldRenderImage={shouldRenderNoResultsImage} />
				</div>;
  }
  const listItemNameMaxLines = activePlugin?.uiOptions?.listItemNameMaxLines;
  if (items && items.length > 0) {
    itemsContent = <Fragment>
					<Box as="h3" // Must remain <h3> for a11y title hierarchy as per https://hello.jira.atlassian.cloud/browse/NAVX-3332
      // `.wiki-content h3` css styles in confluence override ADS/native styles here, so inline styles are needed.
      // Should use css or xcss prop when that CSS is removed/fixed by confluence
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      style={listTitleStyles} id={testIds.resultListTitle} testId={testIds.resultListTitle}>
						<FormattedMessage {...linkListTitle} />
					</Box>
					<VisuallyHidden id="fabric.smartcard.linkpicker.suggested.results">
						{hasSearchTerm && <FormattedMessage {...messages.searchLinkResults} values={{
          count: items.length
        }} aria-live="polite" aria-atomic="true" />}
					</VisuallyHidden>
					<ul id={id} role={role} aria-controls="fabric.smartcard.linkpicker.suggested.results" aria-labelledby={testIds.resultListTitle} aria-readonly={ariaReadOnly} data-testid={testIds.searchResultList} className={ax(["_1LMyvKYbGa _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _313842Pgdg _1DCdHiPgdg _2XsHFMBXau _0adFHshxaA"])}>
						{items.map((item, index) => <LinkSearchListItem id={`${testIds.searchResultItem}-${index}`} item={item} selected={selectedIndex === index} active={activeIndex === index} onFocus={() => onChange(item.objectId)} onKeyDown={handleKeyDown} onSelect={onSelect} key={item.objectId} tabIndex={getTabIndex(index)} ref={el => itemRefCallback(el, item.objectId)} nameMaxLines={listItemNameMaxLines} />)}
					</ul>
				</Fragment>;
  }
  if (isLoading) {
    loadingContent = <MinHeightContainer minHeight={adaptiveHeight ? '80px' : '50px'} className={ax(["_2O5Vij7dHp _0aFT5vbt8w _0hPCNLDIqT"])}>
					<Spinner testId={testIds.searchResultLoadingIndicator} interactionName="link-picker-search-list-loading" size="medium" />
				</MinHeightContainer>;
  }
  return <div id={tabPanelId} ref={ref} className={ax(["_39xV02N91d _0Of8r2dnbC _4kiQYAljYU _3138425zaO _1DCdHi5zaO _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w", className])} {...restProps}>
				{itemsContent}
				{loadingContent}
			</div>;
});